<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2016 by The University of Chicago</p>
<p class="crt">All rights reserved. Published 2016</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">25 24 23 22 21 20 19 18 17 16    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-37789-6 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-38408-5 (e-book)</p>
<p class="crt">DOI: 10.7208/chicago/9780226384085.001.0001</p>
<p class="crtf">This book has been supported by the Gustave Reese Endowment of the American Musicological Society, funded in part by the National Endowment for the Humanities and the Andrew W. Mellon Foundation.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Names: Kramer, Richard, 1938– author.</p>
<p class="cip">Title: Cherubino’s leap : in search of the Enlightenment moment / Richard Kramer.</p>
<p class="cip">Description: Chicago : The University of Chicago Press, 2016. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2016019385 | ISBN 9780226377896 (cloth : alk. paper) | ISBN 9780226384085 (e-book)</p>
<p class="cip">Subjects: LCSH: Music—Germany—18th century—History and criticism. | Music—Austria—18th century—History and criticism. | Enlightenment. | Music—18th century—Philosophy and aesthetics. | Klopstock, Friedrich Gottlieb, 1724–1803—Musical settings—History and criticism. | Music and literature—History—18th century.</p>
<p class="cip">Classification: LCC ML275.3 .K73 2016 | DDC 780.943/09033—dc23 LC record available at <a class="url" href="https://lccn.loc.gov/2016019385" target="_blank">https://lccn.loc.gov/2016019385</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48–1992 (Permanence of Paper).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-kramer-0004.vue?43218afe